<template>
  <div class="news-filters">
    <p
      v-if="title"
      class="news-filters-label"
    >
      {{ title }}
    </p>
    <ul class="news-filters-list">
      <li
        v-for="(filter, i) in filters"
        :key="i"
        class="news-filters-list-link"
      >
        <a
          :href="filter.href"
          class="news-filters-list-item"
          :class="{ 'is-active': filter.isActive === true }"
        >
          {{ filter.label }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'KfNewsFilters',
  props: {
    i18n: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
      default: '',
    },
    filters: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="postcss">
.news-filters {
  &-list {
    @apply flex flex-wrap gap-4;

    @screen md {
      @apply gap-5;
    }

    &-item {
      @apply flex justify-center;
    }
    /* give double class selector / more specificity for overrriding */
    &-link.news-filters-list-link a {
      @apply flex h-10 items-center text-white bg-secondary-bravo justify-center text-sm font-medium px-5 rounded no-underline;
      transition: color 0.3s, background 0.3s;

      &:hover {
        @apply text-white bg-primary-bravo;
      }

      &.is-active {
        @apply bg-primary-bravo;
      }
    }
  }
}
</style>
